module.exports = __webpack_public_path__ + "static/06 - nyu-7a3311246ee9c62301f9a880c7e1cc22.png";